<template>
  <div class="view-wrapper content flex-ui">
    <van-nav-bar title="订单确认" left-arrow @click-left="$router.go(-1)" />
    <div class="grow">
      <div class="scroll-content scroll-content-with-footer">
        <div class="section-group">
          <div class="goods-box">
            <div class="image">
              <img :src="product.ProImage" alt />
            </div>
            <div class="info">
              <div class="info-item">
                <div class="info-item-left">
                  <span class="p-title">{{product.ProName}}</span>
                </div>
                <div class="info-item-right">
                  <span class="p-price">￥{{goods.skuPrice}}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-item-left">
                  <span class="sku-f">{{goods.skuName}}</span>
                </div>
                <div class="info-item-right">
                  <span class="sku-f">x {{goods.count}}</span>
                </div>
              </div>
            </div>
          </div>
          <van-cell-group>
            <van-cell v-if="orderData.AddressId>0" title="运费" :value="'￥'+ orderData.ExpressFee" />
            <van-cell>
              <template slot="title">
                <span class="red">小计</span>
              </template>
              <span class="red">￥{{sumPrice}}</span>
            </van-cell>
          </van-cell-group>
        </div>
        <div class="section-group">
          <van-cell-group>
            <van-field
              v-model="orderData.RechargeAccount"
              clearable
              label="充值账号"
              placeholder="请输入充值账号,如:手机号/邮箱等"
            />
          </van-cell-group>
        </div>
        <div class="section-group">
          <div class="tip-box">
            <div><strong>充值须知</strong> </div>
            <p>1.虚拟商品交易成功后<strong>无法退换货。</strong> </p>
            <p>2.提交前请确认输入的充值账号准确无误，由于账号输入错误导致的充值失败无法退换。</p>
            <p>3.充值账号为您对应充值平台的账号信息，如<strong>绑定的手机号、邮箱、QQ号等</strong>，无法确认请登录您需要充值的平台进行查询确认。</p>
            <p>4.<strong>请勿输入非平台账号的其他信息作为充值账号，以免给您带来不便。</strong> </p>
            <p>5.充值结果有一定的延时性和不确定性，若长时间未收到充值结果，请联系客服处理。</p>
            <p>6.充值失败会进行退款处理，可重新下单购买。</p>
          </div>
        </div>
        <div style="height:20px;"></div>
      </div>
    </div>
    <div class="footer-box">
      <div class="red items">
        <span>￥</span>
        <span class="price">{{sumPrice}}</span>
      </div>
      <div class="btns">
        <van-button
          round
          size="large"
          type="danger"
          class="btn-default"
          @click="submitOrder"
          :loading="payment"
          loading-text="提交中..."
        >提交订单</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zccheck",
  //   props: ["goods", "product"],
  data() {
    return {
      payment: false,
      expressType: 1,
      product: {
        ProId: 0
      },
      goods: {
        count: 1,
        skuId: 0,
        skuName: "",
        skuPrice: 0
      },
      orderData: {
        StockId: 0,
        Count: 0,
        AddressId: 0,
        RechargeAccount: "",
        Name: "",
        Mobile: "",
        ExpressFee: 0,
        IsInvoice: true,
        ExpressType: 1
      }
    };
  },
  computed: {
    sumPrice: function() {
      return (
        Math.round(
          (this.orderData.ExpressFee + this.goods.skuPrice * this.goods.count) *
            100
        ) / 100
      );
    }
  },
  created() {
    //this.initDefaultAddress();
    //this.initData();
  },
  activated() {
    this.initData();
    //this.initDefaultAddress();
    //this.changeAddress();
    this.expressType = 0;
  },
  methods: {
    initData() {
      //console.log("init");
      this.goods.skuId = parseInt(this.$route.query.sku) || 0;
      this.goods.count = parseInt(this.$route.query.count) || 1;
      this.product.ProId = parseInt(this.$route.query.pid) || 0;
      this.orderData.StockId = this.goods.skuId;
      this.orderData.Count = this.goods.count;

      let localProduct = localStorage.getItem("goods-info");
      if (localProduct) {
        let product = JSON.parse(localProduct);
        if (product.ProId === this.product.ProId) {
          //console.log(product);
          this.product = product;
          let sku = this.product.ProSkuList.find(
            s => s.StockId === this.goods.skuId
          );
          if (sku) {
            this.goods.skuName = sku.StockName;
            this.goods.skuPrice = sku.StockPrice;
          }
        } else {
          //sku 变了
        }
      }
    },
    submitOrder() {
      if (
        this.orderData.AddressId <= 0 &&
        this.product.ProType === 1 &&
        this.orderData.ExpressType === 1
      ) {
        this.$toast("请选择地址");
        return;
      }
      if (this.orderData.RechargeAccount === "") {
          this.$toast("请输入充值账号");
          return;
        }
      //提交订单
      this.payment = true;
      this.$ajax
        .post("/api/order/create/single", this.orderData)
        .then(response => {
          this.payment = false;
          if (response.data.code === 1) {
            //success
            if (response.data.data.PayUrl === "") {
              //预约
              this.$router.push({ path: "/order/0" });
            } else {
              this.$toast.loading({
                mask: true,
                message: "跳转支付",
                forbidClick: true
              });
              window.location.href = response.data.data.PayUrl;
            }
          } else {
            //this.$toast.fail(response.data.message);
            this.$dialog
              .alert({
                title: "下单失败",
                message: response.data.message
              })
              .then(() => {
                // on close
              });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped >
@import "../assets/base-var.less";

.tip-box{  
  background: #fff;
  padding: 10px 15px;
  font-size: 14px;
}
.goods-box {
  display: flex;
  background: #fff;
  padding: 10px 15px;
  font-size: 16px;
}

.goods-box .image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
.goods-box .image img {
  max-width: 100%;
  border-radius: 4px;
}
.goods-box .info {
  flex: 1;
}
.info-item {
  display: flex;
  margin-bottom: 5px;
}
.info-item-right {
  width: 60px;
  text-align: right;
}
.info-item-left {
  flex: 1;
  text-align: left;
}
.p-title {
  font-weight: 500;
}
.p-price {
  color: #f44;
}
.sku-f {
  font-size: 12px;
  color: @gray-color;
}
.invoice-box {
  padding: 10px 0;
  background-color: #fff;
}
</style>